import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDialog } from 'react-mui-dialog';
import { COLOURS, inputStyleColour, otusButtonStyleGreen } from '../variables';
import { TryActionWithCatchDialogAsync } from './Utils';
export default function EnableMfaDialog({open, setOpen, usersClient, onValidated}){
  const[code, setCode] = useState('')
  const[validated, setValidated] = useState(false)
  const[qrCode, setQrCode] = useState('')
  const {openDialog} = useDialog()
  const handleValidate = async () =>{
    await TryActionWithCatchDialogAsync(async ()=>{
      var confirmed = await usersClient.checkMfaCode(code)
      if(confirmed != 'true'){
         throw '401'
      }
      else{
        setOpen(false)
        setValidated(true)
      }
    },openDialog, (error) => error=='401' ? 'Code not valid' : null)
    }
    useEffect(async()=>{
        if(open){
          setQrCode(await usersClient.getEnableMfaQrCode())
        }
    },[open])
    useEffect(()=>{
      if(onValidated && validated) 
      {
        onValidated()
        setValidated(false)
      }
    },[validated])
    return(
        <Dialog open={open} onClose={(e) => setOpen(false)}>
        <DialogTitle color={COLOURS.fontColor}>Scan QR code on preferred app and input the code that appears on your app.</DialogTitle>
        <DialogContent>
        <img width={'300px'} src={qrCode}/>
          <TextField
                autoFocus
                margin="dense"
                label="Code"
                type="text"
                onChange={(e) => setCode(e.target.value)}
                value={code}
              sx={inputStyleColour(COLOURS.fontColor)}
              fullWidth
                variant="standard"
              />
        </DialogContent>
        <DialogActions> <Button onClick={(e) => handleValidate()}  sx={otusButtonStyleGreen}>Validate</Button></DialogActions>
      </Dialog>)
}